import React from "react";
import { Link } from "react-router-dom";

const ExternalLinkButton = ({ to, external, className, children, style }) => {
  // Define default link styles to ensure professionalism
  const defaultStyle = {
    textDecoration: "none",
    color: "inherit",
    ...style, // Allow custom styles to override defaults
  };

  if (external) {
    return (
      <a
        href={to}
        className={`${className} hover:text-gray-900 transition-colors`}
        target="_blank"
        rel="noopener noreferrer"
        style={defaultStyle}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      to={to}
      className={`${className} hover:text-gray-900 transition-colors`}
      style={defaultStyle}
    >
      {children}
    </Link>
  );
};

export default ExternalLinkButton;
